module.exports = __webpack_public_path__ + "img/task1.fd6f4a6c.png";